// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-header {
    position: relative;
    height: auto;
    z-index: 10;
    min-height: 60px;
    border-color: #cacaca;
    background: #fff;
    /* box-shadow: 0 2px 0 hsla(0,0%,51%,.1); */
}

.okta-logo {
    display: block;
    margin: 15px 0;
    margin-left: 15%;
    float: left;
}`, "",{"version":3,"sources":["webpack://./src/css/HelpHeader.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf","sourcesContent":[".help-header {\n    position: relative;\n    height: auto;\n    z-index: 10;\n    min-height: 60px;\n    border-color: #cacaca;\n    background: #fff;\n    /* box-shadow: 0 2px 0 hsla(0,0%,51%,.1); */\n}\n\n.okta-logo {\n    display: block;\n    margin: 15px 0;\n    margin-left: 15%;\n    float: left;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
